import React from 'react';
import FlightList from './FlightList';
import FlightStatusFilter from './FlightStatusFilter';
import FlightFilterAndSearchContainer from './FlightFilterAndSearchContainer';
import { useDispatch, useSelector } from 'react-redux';
import { getShowAircraftListPanel } from '../../redux/selectors/flyingPage';
import { setShowAircraftListPanel } from '../../redux/slice/flyingPage/flyingPage';

const FlightContainer: React.FC = () => {
  const showAircraftListPanel = useSelector(getShowAircraftListPanel);
  const dispatch = useDispatch();

  return (
    <div className={`flight-container-wrapper ${showAircraftListPanel ? 'open' : 'closed'}`}>
      <div className="flight-detail-container">
        <div className="flight-detail-filters">
          <FlightFilterAndSearchContainer />
          <FlightStatusFilter />
        </div>
        <FlightList />
      </div>
      <button
        className="flight-detail-container-slider-button material-icons"
        onClick={() => dispatch(setShowAircraftListPanel(!showAircraftListPanel))}
        aria-label={showAircraftListPanel ? 'Hide aircraft list panel' : 'Show aircraft list panel'}
        aria-expanded={showAircraftListPanel}
        type="button"
      />
    </div>
  );
};

export default FlightContainer;
